import React from "react";

/** Production (partner orders): a work board with columns at different stages. */
const ProductionIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M9 4v16M15 4v16" stroke="currentColor" strokeWidth="1.7" />
      <rect x="4.6" y="7" width="2.8" height="4.5" rx="0.8" fill="currentColor" />
      <rect x="10.6" y="7" width="2.8" height="7.5" rx="0.8" fill="currentColor" />
      <rect x="16.6" y="7" width="2.8" height="2.8" rx="0.8" fill="currentColor" />
    </svg>
  );
};

export default ProductionIcon;
